import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_5 = {
  key: 1,
  class: "d-flex align-center text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_erp_url = _resolveComponent("erp-url")!
  const _component_v_row = _resolveComponent("v-row")!

  return ($setup.showCouponContextRow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (!$setup.currentScanner.isAppMembre && $props.batchData.batchId)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label font-weight-bold" }, "Identifiant de Lot", -1)),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("span", null, _toDisplayString($setup.batchId), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, {
              cols: "12",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label font-weight-bold" }, "Permis Chauffeur", -1)),
                _createVNode(_component_v_spacer),
                ($setup.driverId || $setup.erpDriverPartnerId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("p", null, _toDisplayString($setup.driverData), 1),
                      ($setup.erpDriverPartnerId)
                        ? (_openBlock(), _createBlock(_component_erp_url, {
                            key: 0,
                            type: "driver",
                            driverId: $setup.erpDriverPartnerId
                          }, null, 8, ["driverId"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, " Aucune donnée fournie "))
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label font-weight-bold" }, "Véhicule", -1)),
                _createVNode(_component_v_spacer),
                ($setup.vehicleId && ($setup.driverId || $setup.erpDriverPartnerId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("p", null, _toDisplayString($setup.vehicleData), 1),
                      ($setup.erpDriverPartnerId)
                        ? (_openBlock(), _createBlock(_component_erp_url, {
                            key: 0,
                            type: "vehicle",
                            vehicleId: $setup.vehicleId,
                            driverId: $setup.erpDriverPartnerId
                          }, null, 8, ["vehicleId", "driverId"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, " Aucune donnée fournie "))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}